export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sku/room/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sku/room/get?id=${data.id}`,
                data
            })
        },
        queryAll(data) {
            return http.json({
                url: `/sku/room/queryAll`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/sku/room/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/sku/room/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sku/room/delete`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/room.js